import React from "react";
import {
  PLAYER_PLACEHOLDER_HEIGHT,
  PLAYER_PLACEHOLDER_WIDTH,
} from "../../utils/data";
import playerUser from "../../assets/player_user.png";
import { PlayerSelectionBottomSheetType } from "../../apis/types";
import { useSelectCircleStore } from "../../stores/StoreContext";
interface SelectedPlayerCardProps {
  style?: React.CSSProperties;
}

export const GuestPlayerCard: React.FC<SelectedPlayerCardProps> = ({
  style,
}) => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div
      style={{
        ...styles.container,
        ...style,
        opacity: 0.5,
        height: PLAYER_PLACEHOLDER_HEIGHT,
        justifyContent: "center",
      }}
      onClick={() => {
        selectCircleStore.setBottomSheetType(
          PlayerSelectionBottomSheetType.selectPlayers
        );
      }}
       >
      <div
        style={{
          height: 42,
          width: 42,
          borderRadius: 21,
          backgroundColor: "#1c6554",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <img src={playerUser} alt="" style={{ width: 16, height: 17 }} />
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative" as const,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    backgroundColor: "#145a4c",
    borderRadius: 12,
    paddingTop: 7,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
    width: PLAYER_PLACEHOLDER_WIDTH,
  },
};
